/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_wf_minlen = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Min word length`)
};

const es_wf_minlen = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Longitud mínima de palabra`)
};

const de_wf_minlen = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Min. Wortlänge`)
};

const nl_wf_minlen = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minimale woordlengte`)
};

const fr_wf_minlen = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Longueur minimale des mots`)
};

const it_wf_minlen = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lunghezza minima della parola`)
};

const pt_br2_wf_minlen = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comprimento mínimo de palavra`)
};

const pt_wf_minlen = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comprimento mínimo de palavra`)
};

const ja_wf_minlen = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最小単語長`)
};

const zh_wf_minlen = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最小单词长度`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const wf_minlen = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.wf_minlen(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("wf_minlen", locale)
	if (locale === "en") return en_wf_minlen(inputs)
	if (locale === "es") return es_wf_minlen(inputs)
	if (locale === "de") return de_wf_minlen(inputs)
	if (locale === "nl") return nl_wf_minlen(inputs)
	if (locale === "fr") return fr_wf_minlen(inputs)
	if (locale === "it") return it_wf_minlen(inputs)
	if (locale === "pt-BR") return pt_br2_wf_minlen(inputs)
	if (locale === "pt") return pt_wf_minlen(inputs)
	if (locale === "ja") return ja_wf_minlen(inputs)
	return zh_wf_minlen(inputs)
};